import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('sellers', {
  customKeys: {
    list: 'users',
  },
  customEndpoints: {
    list: '/users/proposals_filter_list',
  },
});
